
const base = (website) => {
  const filters = website.portfolio.reduce((accumulator, currentValue) => {
    const filterExists = accumulator.some(filter => filter.categoryDescription === currentValue.category);

    if (!filterExists) {
      accumulator.push({
        categoryDescription: currentValue.category,
        category: currentValue.category.replace(/ /g,'').toLowerCase(),
      });
    }

    return accumulator;
  }, []);

  return filters;
};

export const PortfolioFiltersFactory = {
  getBase: base,
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/factories/PortfolioFiltersFactory.js